export const agataMccarthy = {
    'meta': {
        'title': 'Psychiatra dzieci i młodzieży Agata McCarthy • COLLIGO',
        'description': 'Jestem lekarzem specjalistą psychiatrii dzieci i młodzieży. Ukończyłam studia na Wydziale Lekarskim na Gdańskim Uniwersytecie Medycznym w 2012 r.'
    },
    'url': {
        'address': '/torun/zespol/psychiatra-dzieciecy-agata-mccarthy/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/agata-mccarthy.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra dzieci i młodzieży Agata McCarthy'
        }
    }
}